import React from 'react';
import { Link } from 'react-router-dom';

const DescripcionComp = () => {
    return (
        <div className='descripcionComp homeCard heroes'>
            <p>
                <strong>Forallia</strong> es la plataforma web y el bot del streamer Narux: un mundo de
                fantasía donde los espectadores se convierten en héroes corruptos. Vincula tu cuenta de
                Twitch o YouTube y <strong className='accent'>gana premios reales solo por ver el directo</strong>: acumula
                birux viendo los streams, sube en las ligas con premios de tus videojuegos favoritos, escala
                el Hall of Fama, completa misiones diarias, abre cofres del Overbox y canjea recompensas
                escribiendo palabras clave en el chat. Sigue a Narux desde nuestras{' '}
                <Link to='/redes'>redes</Link>.
            </p>
        </div>
    );
};

export default DescripcionComp;
